export type Invite = {
  organization: string;
  invitation: string;
  organization_name: string | undefined;
  display_name: string | undefined;
};

export function encodeInvite(invite: Invite) {
  return `sp_invite:${btoa(JSON.stringify(invite))}`;
}

export function decodeInvite(invite: string): Invite | null {
  if (invite.startsWith("sp_invite:")) {
    try {
      return JSON.parse(atob(invite.replace("sp_invite:", "")));
    } catch {
      return null;
    }
  }
  return null;
}
